import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ServiceManagerPageRoutingModule } from './service-manager-routing.module';

import { ServiceManagerPage } from './service-manager.page';
import { StylistPickerModule } from '../../../components/stylist-picker/stylist-picker.module';
import { SingleStylistServiceManagerComponentModule } from './single-stylist-service-manager/single-stylist-service-manager.module';
import { AllStylistServiceManagerComponentModule } from './all-stylist-service-manager/all-stylist-service-manager.module';
import { ServiceDetailFormComponentModule } from '../service-detail-form/service-detail-form.module';
import { ServiceCategoryFormComponentModule } from '../service-category-form/service-category-form.module';
import { SalonMonsterLoadMaskModule } from '../../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../../components/smr-tap-retry/smr-tap-retry.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    ServiceManagerPageRoutingModule,
    StylistPickerModule,
    SingleStylistServiceManagerComponentModule,
    AllStylistServiceManagerComponentModule,
    ServiceDetailFormComponentModule,
    ServiceCategoryFormComponentModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule
  ],
  declarations: [ServiceManagerPage
    ],
  exports: [ ServiceManagerPage],
 /* schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],*/
})
export class ServiceManagerPageModule {}
